const GLOBAL_ROUTES = require('./global.json');

module.exports = {
  routerConfig: GLOBAL_ROUTES,
};
